import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RadioGroup, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useFilterSettings } from "../../hooks/use-filter-settings";
import { MyPagesRoutes } from "../../types/routes";
import { FilterSettingsRowRadio, FilterSettingsRowSwitch } from "./filter-settings-row";

/**
 *
 * @description returns filters based on what the location path is
 */
const LocationFilter = () => {
	const [filterSettings, setFilterSettings] = useFilterSettings();
	const { t } = useTranslation();
	const location = useLocation();
	const locationPath = location.pathname.replace("/", "");

	switch (locationPath) {
		case MyPagesRoutes.Documents:
			return (
				<>
					<FilterSettingsRowSwitch
						key={"showESigningDocuments"}
						name={t("document_filterSettings_esigning")}
						isChecked={filterSettings.showESigningDocuments}
						setFunction={() =>
							setFilterSettings("showESigningDocuments", !filterSettings.showESigningDocuments)
						}
						data-testid="filter-esigned-documents-toggle"
					/>
					<FilterSettingsRowSwitch
						key={"showDocuments"}
						name={t("document_filterSettings_documents")}
						isChecked={filterSettings.showDocuments}
						setFunction={() => setFilterSettings("showDocuments", !filterSettings.showDocuments)}
						data-testid="filter-documents-toggle"
					/>
				</>
			);
		case MyPagesRoutes.Messages:
			return (
				<FilterSettingsRowSwitch
					key={"showUnreadMessages"}
					name={t("messages_filterSettings_read")}
					isChecked={filterSettings.showUnreadMessages}
					setFunction={() => setFilterSettings("showUnreadMessages", !filterSettings.showUnreadMessages)}
					data-testid="filter-unread-messages-toggle"
				/>
			);
		case MyPagesRoutes.Schedule:
			return (
				<>
					<FilterSettingsRowSwitch
						name={t("filterSettings_showApplicationShifts")}
						isChecked={filterSettings.showApplicationShifts}
						setFunction={() =>
							setFilterSettings("showApplicationShifts", !filterSettings.showApplicationShifts)
						}
						data-testid="filter-open-shifts-toggle"
					/>
					<FilterSettingsRowSwitch
						name={t("filterSettings_showDeclinedShifts")}
						isChecked={filterSettings.showDeclinedShifts}
						setFunction={() => setFilterSettings("showDeclinedShifts", !filterSettings.showDeclinedShifts)}
						data-testid="filter-declined-shifts-toggle"
					/>
				</>
			);
		case MyPagesRoutes.Tip:
			return (
				<RadioGroup
					value={filterSettings.showCalendarMonth ? "month" : "year"}
					onValueChange={({ value }) => setFilterSettings("showCalendarMonth", value === "month")}
					rowGap={ThemeSpaceVariable.None}
				>
					<FilterSettingsRowRadio
						key={"calendarMonth"}
						name={t("tip_filterSettings_calendarMonth")}
						value="month"
					/>
					<FilterSettingsRowRadio
						key={"calendarYear"}
						name={t("tip_filterSettings_calendarYear")}
						value="year"
					/>
				</RadioGroup>
			);
		case MyPagesRoutes.News:
			return (
				<>
					<FilterSettingsRowSwitch
						name={t("messages_filterSettings_read")}
						isChecked={!filterSettings.showReadNews}
						setFunction={() => setFilterSettings("showReadNews", !filterSettings.showReadNews)}
						data-testid="filter-unread-news-toggle"
					/>
				</>
			);
		default:
			return false;
	}
};

export default LocationFilter;
